var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMysteryBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.71,349.14H264a5.87,5.87,0,0,1-5.86-5.86V80A5.87,5.87,0,0,1,264,74.15H444.71A5.87,5.87,0,0,1,450.57,80V343.28A5.87,5.87,0,0,1,444.71,349.14ZM264,74.4A5.61,5.61,0,0,0,258.35,80V343.28a5.61,5.61,0,0,0,5.61,5.61H444.71a5.61,5.61,0,0,0,5.61-5.61V80a5.61,5.61,0,0,0-5.61-5.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.28,349.14H55.53a5.87,5.87,0,0,1-5.86-5.86V80a5.87,5.87,0,0,1,5.86-5.86H236.28A5.87,5.87,0,0,1,242.14,80V343.28A5.87,5.87,0,0,1,236.28,349.14ZM55.53,74.4A5.61,5.61,0,0,0,49.92,80V343.28a5.61,5.61,0,0,0,5.61,5.61H236.28a5.61,5.61,0,0,0,5.61-5.61V80a5.61,5.61,0,0,0-5.61-5.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.79,
    y: 410.21,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.72,
    y: 89.42,
    width: 34.57,
    height: 10.13,
    rx: 1.5,
    transform: "translate(394.01 188.97) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.86,
    y: 102.34,
    width: 34.57,
    height: 10.13,
    rx: 1.5,
    transform: "translate(356.29 214.8) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9,
    y: 241.32,
    width: 34.57,
    height: 10.13,
    rx: 1.5,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.75,
    y: 254.24,
    width: 34.57,
    height: 10.13,
    rx: 1.5,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.16,
    y: 251.54,
    width: 34.57,
    height: 10.13,
    rx: 1.5,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.87,
    y: 251.54,
    width: 34.57,
    height: 10.13,
    rx: 1.5,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 264.45,
    width: 34.57,
    height: 10.13,
    rx: 1.5,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.55,
    y: 324.25,
    width: 36.07,
    height: 85.96,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.04,
    y: 324.25,
    width: 85.96,
    height: 85.96,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.91,
    y: 324.25,
    width: 10.62,
    height: 85.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.37,
    y: 324.25,
    width: 36.07,
    height: 85.96,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.86,
    y: 324.25,
    width: 85.96,
    height: 85.96,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.72,
    y: 324.25,
    width: 10.62,
    height: 85.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.98,
    y: 369.98,
    width: 36.07,
    height: 40.24,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.47,
    y: 369.98,
    width: 85.96,
    height: 40.24,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.34,
    y: 369.98,
    width: 10.62,
    height: 40.12,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.22,
    y: 284.01,
    width: 36.07,
    height: 40.24,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.72,
    y: 284.01,
    width: 85.96,
    height: 40.24,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.58,
    y: 284.01,
    width: 10.62,
    height: 40.12,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.93,
    y: 93.42,
    width: 79.02,
    height: 79.02,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.93,
    y: 97.42,
    width: 71.02,
    height: 71.02,
    transform: "translate(449.37 -183.51) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.68,152.31s13-26.74,40.27-27.27v43.4H316.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.93,144.8s11.72-6.15,23.64-1.63c15,5.66,23.65,25.27,23.65,25.27H280.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.29,
    cy: 119.93,
    r: 12.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.76,
    y: 93.42,
    width: 69.33,
    height: 134.21,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.32,
    y: 129.86,
    width: 126.21,
    height: 61.33,
    transform: "translate(256.95 64.1) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 136.53,
    r: 12.53,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.23,223.63S92.75,149,127.09,142.3v81.33H77.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.76,179.34s7.9-7.62,20.42-3.06c23.52,8.55,36.65,47.35,36.65,47.35H65.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.3,
    cy: 131.23,
    r: 20.94,
    transform: "translate(-13.06 50.64) rotate(-7.05)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.3,
    cy: 131.23,
    r: 19.29,
    transform: "translate(184.4 494.99) rotate(-76.83)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.63,
    y: 113.7,
    width: 0.72,
    height: 4.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.63,
    y: 144.63,
    width: 0.72,
    height: 4.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.51,
    y: 130.82,
    width: 4.02,
    height: 0.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.45,
    y: 130.82,
    width: 4.02,
    height: 0.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.92,
    y: 119.88,
    width: 4.02,
    height: 0.72,
    transform: "translate(36.49 328.58) rotate(-44.99)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.04,
    y: 141.75,
    width: 4.02,
    height: 0.72,
    transform: "translate(14.7 319.7) rotate(-45.02)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.69,
    y: 118.23,
    width: 0.72,
    height: 4.02,
    transform: "translate(30.14 313.22) rotate(-45.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.57,
    y: 140.1,
    width: 0.72,
    height: 4.02,
    transform: "translate(21.02 334.99) rotate(-44.99)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.84,
    y: 128.66,
    width: 0.62,
    height: 7.33,
    transform: "translate(134.86 462.69) rotate(-68.51)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.3 131.49 393.05 131.49 393.05 130.87 403.68 130.87 403.68 122.14 404.3 122.14 404.3 131.49",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.48,454c0,3.5-96.59,6.34-215.74,6.34S37,457.52,37,454s96.59-6.33,215.74-6.33S468.48,450.52,468.48,454Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--mistery-box--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "385.33 205.79 404.3 222.81 321.99 222.81 305.91 205.79 385.33 205.79",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.33 205.79 404.3 222.81 321.99 222.81 305.91 205.79 385.33 205.79",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.91,
    y: 205.79,
    width: 79.46,
    height: 79.46,
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.91,
    y: 205.79,
    width: 79.46,
    height: 79.46,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.39,
    y: 205.79,
    width: 79.46,
    height: 79.46,
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.42 205.79 261.45 222.81 343.76 222.81 359.84 205.79 280.42 205.79",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.42 205.79 261.45 222.81 343.76 222.81 359.84 205.79 280.42 205.79",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.41,233.17c7.4,0,12.43,4.36,12.43,11.55,0,7.79-5.52,11.22-12.93,11.22l-.22,4.37h-5.47l-.28-8.68h1.82c6.25,0,11.06-1.11,11.06-6.91,0-3.87-2.38-6.25-6.36-6.25s-6.41,2.21-6.41,6.08h-5.91C309.08,237.86,313.89,233.17,321.41,233.17Zm-3.54,39.35a4,4,0,1,1,4-4A4,4,0,0,1,317.87,272.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.62,
    y: 285.25,
    width: 93.66,
    height: 8.23,
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.62,
    y: 285.25,
    width: 93.66,
    height: 8.23,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.28,
    y: 285.25,
    width: 34.79,
    height: 8.23,
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.28,
    y: 285.25,
    width: 34.79,
    height: 8.23,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.97,
    y: 293.48,
    width: 5.64,
    height: 154.89,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.97,
    y: 293.48,
    width: 5.64,
    height: 154.89,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "331.61 297.33 325.97 299.67 325.97 293.48 331.61 293.48 331.61 297.33",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.33,445.22h38.93a8.13,8.13,0,0,1,8.13,8.13v0a0,0,0,0,1,0,0H301.19a0,0,0,0,1,0,0v0A8.13,8.13,0,0,1,309.33,445.22Z",
    style: {
      fill: "#7E57C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87,373.05s6.82-2.49,8.59,4.73,6.82,5.37,7.78,3.78c1.89-3.12,2.15-14.41-1.09-15.09C98.35,365.65,88.31,369.75,87,373.05Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87,373.05s6.82-2.49,8.59,4.73,6.82,5.37,7.78,3.78c1.89-3.12,2.15-14.41-1.09-15.09C98.35,365.65,88.31,369.75,87,373.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M102.23,366.47c-8,.11-10.12,7.14-11.41,13.34L88.22,375l1.84,8.62c-.2.95-.4,1.82-.64,2.57a13,13,0,0,1-7.87,8s-.36-2.48-.68-6h0l2.92-4.58-3.17,1.33c-.35-5.46-.4-12,.93-15.77,2.57-7.23,9.47-5,9.47-5Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.17,358.88s-4.2-1.27-8.6,4.74c-4.23,5.78-5.92,6.46-8.79,4.21s-1.14-14.85,2.11-15.53C110.76,351.49,120.8,355.59,122.17,358.88Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.17,358.88s-4.2-1.27-8.6,4.74c-4.23,5.78-5.92,6.46-8.79,4.21s-1.14-14.85,2.11-15.53C110.76,351.49,120.8,355.59,122.17,358.88Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M135.66,391.71a19.23,19.23,0,0,1-8.8-6.55l4.63-10.86-6.35,7.91a14.78,14.78,0,0,1-.71-1.87c-2.75-8.71-2.19-27.63-18-27.86l15.73-3.58s9.84-3.18,13.51,7.14a36.87,36.87,0,0,1,1.56,10.13l-5.73-5.3s4,5.76,5.79,8.16A173.48,173.48,0,0,1,135.66,391.71Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.15,342.12s6.83-2.49,8.6,4.74,10.65,10,11.57,6.46c1-3.77-1.18-17.2-4.43-17.88C94,334.63,83.52,338.83,82.15,342.12Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.15,342.12s6.83-2.49,8.6,4.74,10.65,10,11.57,6.46c1-3.77-1.18-17.2-4.43-17.88C94,334.63,83.52,338.83,82.15,342.12Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M98.18,335.5c-12.93.19-15.1,13-17,22.45l-6.59-9.51c.08.28,3.57,11.62,4.93,16.11-3,7.94-10.9,10.4-10.9,10.4s-2.19-15.17-1.49-26.82l5.34-4.45-5.05,1.25a26.48,26.48,0,0,1,1.2-5.65c3.67-10.31,13.52-7.13,13.52-7.13Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.32,398.65h0a.46.46,0,0,1-.4-.5A190.1,190.1,0,0,0,96,324.37a.46.46,0,0,1,.28-.58.46.46,0,0,1,.57.29c.12.33,11.4,34.12,6.9,74.17A.45.45,0,0,1,103.32,398.65Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.11,
    y: 395.75,
    width: 34.61,
    height: 4.85,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.11,
    y: 395.75,
    width: 34.61,
    height: 4.85,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.13,400.6H91.51c-2.83,6.58-12,26-12,31.73,0,6.79,8.46,20.93,8.46,20.93,0,1,30.71,1,30.71,0,0,0,8.46-14.14,8.46-20.93C127.14,426.6,118,407.18,115.13,400.6Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sspeech-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152.15,
    cy: 109.24,
    r: 21.05,
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152.15,
    cy: 109.24,
    r: 21.05,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.15,130.72a21.48,21.48,0,1,1,21.47-21.48A21.5,21.5,0,0,1,152.15,130.72Zm0-42.09a20.62,20.62,0,1,0,20.61,20.61A20.64,20.64,0,0,0,152.15,88.63Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.32,97.55c4.55,0,7.65,2.68,7.65,7.11,0,4.79-3.4,6.9-8,6.9l-.14,2.69h-3.36l-.17-5.34h1.12c3.84,0,6.8-.68,6.8-4.25a3.57,3.57,0,0,0-3.91-3.85c-2.42,0-3.95,1.36-3.95,3.74h-3.64C144.73,100.44,147.69,97.55,152.32,97.55Zm-2.18,24.22a2.49,2.49,0,1,1,2.45-2.49A2.45,2.45,0,0,1,150.14,121.77Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.31,125.66l6.87,3.41a.43.43,0,0,0,.6-.55l-3-7.79A21.43,21.43,0,0,1,165.31,125.66Z",
    style: {
      fill: "#7E57C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.77,164c1,4.84,42.12,2.92,40.2-3.33a28.55,28.55,0,0,0-1.5-3.25c-2.67-5.75-7.12-13-21.49-12.93C179.33,144.52,167.94,149.75,170.77,164Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.75 435.85 223.86 446.51 229.49 446.51 230.25 435.85 221.75 435.85",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.75,445.16a2.45,2.45,0,0,1,2.43-.87c1.35.45,3.12,2.67,3.12,2.67s7.35,2.36,9.34,2.48,3.72,1.24,4.46,5.09H224s-.95-8.69-1.1-10.17,2.21.37,2.21.37Z",
    style: {
      fill: "#7E57C2"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.39,453.38l-4.34,0-19-.2c-.24,0-.24-.38,0-.37l1.28,0a.08.08,0,0,1,0-.05,4,4,0,0,0-2-5.09.18.18,0,0,1,.18-.32,4.33,4.33,0,0,1,2.15,5.46l2.67,0,19,.2C247.63,453,247.63,453.39,247.39,453.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.45,448.47a2.34,2.34,0,0,1,3.44-.62c.19.14.38-.18.19-.32a2.71,2.71,0,0,0-4,.75c-.14.2.18.39.32.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.52,449.1a2.34,2.34,0,0,1,3.44-.63c.2.15.38-.17.19-.32a2.71,2.71,0,0,0-4,.76c-.14.2.19.38.32.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.67,449.72a2.33,2.33,0,0,1,3.43-.62c.2.14.38-.18.19-.32a2.7,2.7,0,0,0-3.95.76c-.13.19.19.38.33.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.34 435.93 172.51 446.51 178.14 446.51 179.83 435.93 171.34 435.93",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4,445.16a2.44,2.44,0,0,1,2.42-.87c1.36.45,3.13,2.67,3.13,2.67s7.35,2.36,9.34,2.48,3.72,1.24,4.46,5.09H172.69s-.95-8.69-1.1-10.17,2.21.37,2.21.37Z",
    style: {
      fill: "#7E57C2"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196,453.38l-4.34,0-19-.2c-.24,0-.24-.38,0-.37l1.28,0a.08.08,0,0,1,0-.05,4,4,0,0,0-2-5.09.18.18,0,0,1,.18-.32,4.33,4.33,0,0,1,2.15,5.46l2.67,0,19,.2C196.28,453,196.28,453.39,196,453.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.1,448.47a2.34,2.34,0,0,1,3.44-.62c.19.14.38-.18.19-.32a2.7,2.7,0,0,0-3.95.75c-.14.2.18.39.32.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.17,449.1a2.34,2.34,0,0,1,3.44-.63c.19.15.38-.17.19-.32a2.71,2.71,0,0,0-4,.76c-.14.2.19.38.32.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.32,449.72a2.33,2.33,0,0,1,3.43-.62c.2.14.38-.18.19-.32a2.7,2.7,0,0,0-3.95.76c-.13.19.19.38.33.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.88,436.23h12.43c1.08-16,4.12-69.07,1.72-95.33,1.73-36.43-3.84-84.78-3.84-84.78H190.8s2.89,32.36,15.84,84.26C206.55,381.5,216.59,422.61,219.88,436.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.52,331.66c7.12-29.09.87-66.8.87-66.8l-6.15,43.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.4 435.92 219.31 440.64 233.57 440.58 233.57 435.85 218.4 435.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,436.69H182c4.43-16.47,13.33-69.43,14.75-95.69,7.05-36.43,10.42-84.88,10.42-84.88H167.78s-3.67,32.73,1.72,84.63C168.45,386,169.28,422.61,169.57,436.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.48 435.9 168.45 440.59 182.82 440.59 183.58 435.91 168.48 435.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.34,262.06C208,272.56,163.51,265,163.51,265c.53-13.36,1-39.82.81-61.81,0-.51,0-1,0-1.53,0-3.12-.08-6.14-.14-9,0-.35,0-.7,0-1C164,186,163.81,181,163.55,177c-.5-7.49,3.57-14.46,11-15.71,2.25-.38,4.68-.71,7.21-1l1.83-.19a177.62,177.62,0,0,1,21.75-.79l1.05,0,.56,0,.91,0c3.13.13,6.1.36,8.76.71,6,.78,11.41,5.55,11.51,11.65.09,5.59.64,17.39,1.43,30.7.3,5,.64,10.31,1,15.53C232,238.55,233.8,258.47,235.34,262.06Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.63,237.61a.08.08,0,0,1,0,0l0,0a.27.27,0,0,0-.13,0l-4,7.43-.76-.43-.19-.12-.12-.08-.22-.16-.46-.32-.37-.28c-.51-.38-.92-.72-1.36-1.08-.83-.71-1.62-1.41-2.39-2.12-1.53-1.41-3-2.82-4.46-4.25-2.88-2.89-5.67-5.83-8.38-8.85s-5.36-6.11-8-9.42c-.65-.83-1.31-1.69-2-2.61-.33-.48-.65-.92-1-1.47s-.68-1.09-1.07-1.82l-.31-.66-.16-.33-.22-.61-.19-.64a5.34,5.34,0,0,1-.21-1.06,8.82,8.82,0,0,1,0-2l.06-.49c0-.15.06-.34.08-.4l.15-.53a10.45,10.45,0,0,1,.4-1.06l.23-.5.13-.25.05-.09.43-.71c.34-.54.5-.75.72-1.06.85-1.17,1.53-2,2.24-2.85,2.79-3.29,5.55-6.2,8.34-9.15s5.61-5.78,8.48-8.57c5.71-5.63,11.51-11.1,17.56-16.37l11.44,12.58c-5.69,5.45-11.56,10.78-17.41,16.06l-8.74,7.92c-2.8,2.51-5.62,5.1-8.15,7.58q.3.54.63,1.08c1.94,3.2,4.14,6.45,6.3,9.69s4.42,6.47,6.68,9.64c1.12,1.6,2.25,3.18,3.4,4.71.57.77,1.15,1.5,1.71,2.21l.79,1,.31.37Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.9,210.69h0a.25.25,0,0,1-.23-.27c1.46-20.61-3.64-42.1-3.69-42.31a.25.25,0,0,1,.49-.12c.05.22,5.17,21.77,3.7,42.47A.25.25,0,0,1,196.9,210.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.67,210.22h0a.25.25,0,0,1-.23-.26c1.46-20.62-3.63-42.1-3.68-42.31a.25.25,0,1,1,.48-.12c.05.21,5.17,21.77,3.7,42.46A.25.25,0,0,1,208.67,210.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.55,218A159.12,159.12,0,0,1,208,168.75l21.56,33.72C229.84,207.51,230.18,212.78,230.55,218Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,231.06s1.94,13.12,1.25,20.67c0,0,21.54,3.38,44.21-1.64a49.46,49.46,0,0,0-1.21-20.36C208.93,229.06,194,229.68,178,231.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.55,117.55a16.37,16.37,0,0,0-13,.76c-2.63,1.37-4.91,3.46-4.85,6.6.13,7.33,2.17,19.58,2.17,19.58l24.73-11.18s1.8-6.13-1.09-10A16,16,0,0,0,210.55,117.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.78,132.58s.54-2.12-1.92-6.08.24-6.41,2.12-5.85c0,0-1-2.43.66-3.26s2.46.11,2.46.11a19,19,0,0,1,14.54-3.28c6.75,1.34,11.73-3.37,14.24-1.54s-2,3.55-2,3.55,4,2.23,3.42,4.31-4.34,2.24-4.34,2.24,3.85,2.56,2.28,4.26-6.47-.36-6.47-.36S198.3,126.58,192.78,132.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.65,153.6h0a.3.3,0,0,0,0,.08l-1.56,4.06a14.58,14.58,0,0,0-.31,2.52,13.82,13.82,0,0,0,.09,2c.78,1.36.91,4.26-2.35,3.92-4.12-.42-11.1-6.88-11.18-8.73,2.52-5.41,4.91-12.19,5.18-17.6l4.15,5.59Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205.61,153.69l-1.56,4.06c-2.45-1.46-4.87-4.28-5.18-7.09-.22-2,.87-3.78,1.68-3.79Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M217,146.09c-.34.88-.71,1.74-1.1,2.59-3.44,7.5-13.12,7.17-18.47.78,0,0,0,0,0,0a14,14,0,0,1-1.32-1.85c-3.25-5.4-1.88-9.14-.36-17.79a12,12,0,0,1,18.83-7.75C221.38,127,220.41,137.28,217,146.09Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,145.27a1.41,1.41,0,1,1-.65-2.14A1.61,1.61,0,0,1,209.25,145.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,128.46c2.25-.31.72-2.8,1.2-4.2,1.58-4.53,13.91-1.43,15.33,5.51,0,0-.34-5.29-4.19-8.53s-12.13-4.71-15.94-1-3.83,10.34-3.83,10.34a2.82,2.82,0,0,0,.64,2c.41.4,1.13,2.23,2.33,2.71,1,.42,1.8.25,2.18-1.23S201.44,128.67,203,128.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.69,134.61a8.3,8.3,0,0,0,2.72,5.76c2.19,1.95,4.56.31,5-2.43.42-2.46-.21-6.43-2.92-7.33s-5,1.3-4.83,4",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.36,135.1c-.16.68.07,1.31.51,1.41s.92-.35,1.08-1-.06-1.31-.5-1.41-.93.35-1.09,1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.74,136.78c-.16.67.07,1.3.51,1.41s.92-.36,1.08-1-.06-1.3-.5-1.4-.92.35-1.09,1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.38,134.76a.37.37,0,0,1-.26-.24,1.85,1.85,0,0,0-.83-1.17,2.11,2.11,0,0,0-1.43-.12.33.33,0,0,1-.43-.23.34.34,0,0,1,.23-.43,2.72,2.72,0,0,1,2,.17,2.46,2.46,0,0,1,1.17,1.59.34.34,0,0,1-.24.43A.25.25,0,0,1,218.38,134.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.93,132a.33.33,0,0,1-.16-.07.38.38,0,0,1-.05-.53,3,3,0,0,1,1.89-1,2.7,2.7,0,0,1,2,.74.39.39,0,0,1,0,.54.38.38,0,0,1-.53,0,2,2,0,0,0-1.44-.56,2.19,2.19,0,0,0-1.37.74A.38.38,0,0,1,206.93,132Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,135.6a21.37,21.37,0,0,0,1.28,5.21c.94,2.14-2.75,1.34-2.75,1.34Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.14,180.37,164.3,201.61c0-3.12-.08-6.14-.14-9,0-.35,0-.7,0-1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.16,212.18A8.85,8.85,0,0,1,228,208.66l-.44-.74-.87-1.49c-.15-.24-.29-.49-.43-.74-.47-.8-.93-1.61-1.4-2.42l-1.55-2.71-1.54-2.71c-.52-.9-1-1.81-1.53-2.71s-1-1.82-1.52-2.73l-.18-.33-2.84-5.14c-2-3.66-4-7.33-5.88-11s-3.82-7.42-5.61-11.21l7.87-5.15c2.75,3.16,5.39,6.4,8,9.65l.87,1.09,6-3.14c1.5,2.64,2.92,5.32,4.32,8s2.77,5.4,4.11,8.12,2.68,5.45,4,8.2,2.59,5.5,3.85,8.26l.35.78A8.8,8.8,0,0,1,239.16,212.18Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26,200.56,223,200q-1.41-2.43-2.76-4.89c.5.9,1,1.81,1.53,2.71Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,161.58c-.19,1.52-1.29,3.88-3.5,3.8a12.45,12.45,0,0,1-4-.87h0c-1.69-.43-4.86-1.5-5.95-3.59-1.53-2.92.86-7.5.86-7.5-2.48-2.35-5.41-6.39-3.36-5.47s10.09,6.54,13,5.9c2.68-.59,3.62-2.91,4.62-2.44s-1,2.62-2.06,4.78A18.44,18.44,0,0,1,212,161.58Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.79,164.55l-.11,0c-.2-.1-5.06-2.38-5.94-4.86-.78-2.22.9-5.41,1.36-6.21a19.49,19.49,0,0,1-3.66-4c-.35-.72-.43-1.24-.24-1.58a.57.57,0,0,1,.44-.3c1,0,2.08.78,3.53,1.85a28.48,28.48,0,0,0,5.68,3.45c4.37,1.92,5.16.75,5.68,0l.19-.29c.58-.83,1.55-2.22,3.19-1.55a.24.24,0,0,1,.13.32.24.24,0,0,1-.32.14c-1.18-.47-1.87.34-2.59,1.38l-.19.28c-.78,1.15-1.91,2.12-6.29.2a28.69,28.69,0,0,1-5.77-3.51c-1.33-1-2.37-1.74-3.21-1.76,0,0,0,0,0,.07s-.11.34.26,1.1c.68,1.4,3.66,4,3.69,4a.24.24,0,0,1,0,.32s-2.22,3.68-1.42,6,5.64,4.55,5.68,4.57a.25.25,0,0,1-.1.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M215.58,163.58,237,196.17S234.5,185.25,215.58,163.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.17,237.78s8.62,2.65,9.31,4.33-2.14,1.25-2.14,1.25,3.07.64,3,1.83c-.1,1.42-3.05.95-3.05.95s2.49.62,2.34,1.66-3.53.77-3.53.77,1.68.73,1.1,1.38-6.84.2-8.82-1.21-.7-9.3-.12-11-.44-3.5,2-5.47l-.08,5.53Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.32,243.49h0L166,242.13a.14.14,0,0,1-.1-.16.16.16,0,0,1,.17-.1l5.3,1.36a.13.13,0,0,1,.1.16A.13.13,0,0,1,171.32,243.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.11,246.25h0l-5.19-.95a.12.12,0,0,1-.11-.15A.14.14,0,0,1,166,245l5.2,1a.13.13,0,0,1,0,.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.9,248.67l-3.89-.6a.13.13,0,0,1-.11-.15.14.14,0,0,1,.16-.11l3.88.6a.13.13,0,0,1,.11.15A.12.12,0,0,1,169.9,248.67Z",
    style: {
      opacity: 0.2
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysteryBox);
export default __webpack_public_path__ + "static/media/mystery-box.b4dd7267c10aea4dae12ff55578f03c6.svg";
export { ForwardRef as ReactComponent };